import React from 'react';
import { Code2, GraduationCap, Lightbulb } from 'lucide-react';
import { aboutContent } from '../data/mock';

const AboutSection = () => {
  const icons = [GraduationCap, Code2, Lightbulb];

  return (
    <section id="about" className="about-section">
      <div className="about-container">
        <div className="section-header">
          <span className="section-subtitle">{aboutContent.subtitle}</span>
          <h2 className="section-title">{aboutContent.title}</h2>
        </div>
        
        <div className="about-content">
          <div className="about-text">
            {aboutContent.paragraphs.map((paragraph, index) => (
              <p key={index} className="about-paragraph">
                {paragraph}
              </p>
            ))}
          </div>
          
          <div className="about-highlights">
            {aboutContent.highlights.map((highlight, index) => {
              const Icon = icons[index];
              return (
                <div key={index} className="highlight-card">
                  <div className="highlight-icon">
                    <Icon size={32} />
                  </div>
                  <div className="highlight-content">
                    <h3 className="highlight-label">{highlight.label}</h3>
                    <p className="highlight-description">{highlight.description}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      
      <div className="about-decoration">
        <div className="decoration-line"></div>
      </div>
    </section>
  );
};

export default AboutSection;
